import { Group, Stack, Text } from "@mantine/core";
import { STATE } from "../../theme/mantine-theme";

/**
 * One number and what it is.
 *
 * Three sizes, because the design uses a number three ways: the hero figure a
 * card exists to show, a supporting figure beside it, and an inline figure in
 * a row of meta.
 *
 * Every figure gets `.num` - tabular figures. Proportional digits make a
 * column of numbers ripple, and a rippling column is one people misread. That
 * is not a nicety on a screen showing stock counts and rupees.
 */
export function Metric({
  value,
  label,
  size = "kpi",
  delta,
}: {
  value: string | number;
  label?: string;
  size?: "hero" | "kpi" | "inline";
  /** A change against the previous period. Sign decides the colour. */
  delta?: { value: string; direction: "up" | "down" };
}) {
  const fz = size === "hero" ? "32px" : size === "kpi" ? "26px" : "14px";
  const fw = size === "inline" ? 600 : 600;
  const lh = size === "hero" ? 1.1 : size === "kpi" ? 1.15 : 1.45;

  return (
    <Stack gap={2}>
      <Group gap="xs" align="baseline" wrap="nowrap">
        <Text className="num" fz={fz} fw={fw} lh={lh} c="gray.9">
          {value}
        </Text>
        {delta && (
          <Text
            className="num"
            fz="sm"
            fw={700}
            // Read from the theme's delta tokens rather than a local green.
            c={delta.direction === "up" ? STATE.positive.fg : STATE.negative.fg}
          >
            {delta.direction === "up" ? "▲" : "▼"} {delta.value}
          </Text>
        )}
      </Group>
      {label && (
        <Text fz="sm" c="gray.6" lh={1.4}>
          {label}
        </Text>
      )}
    </Stack>
  );
}
